<template>
  <div class="current-store-hours" v-show="showStoreHours">
    <div v-show="isOpen">
      {{ "dealers.hours.openUntil" | t }}
      <span v-if="!!storeHours"
        class="time"
      >{{ closeText | toShortTime({lowercase:true}) }}</span>
    </div>
    <div v-show="!isOpen">
      {{ "dealers.hours.opens" | t }}
      <span class="time">{{ getNextOpenDay() }}</span>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";

export default {
  name: 'CurrentStoreHours',
  props: {
    storeHours: {
      type: Object,
      default: null
    }
  },
  computed: {
    ...mapGetters('DealerHeader', ['isModalOpen', 'showStoreHours']),
    isOpen() {
      if (this.storeHours == null) return;
      if (this.storeHours.today.close == null) return false;

      let hours = new Date().getHours();
      let minutes = new Date().getMinutes();
      let now = new Date(0,0,0,hours,minutes,0,0)

      let closeLong = this.storeHours.today.close;
      let closeTime = closeLong.substring(closeLong.indexOf('T')+1)
      let h = closeTime.substring(0,2);
      let m = closeTime.substring(3,5);
      let close = new Date(0,0,0,h,m,0,0);
      return close > now;
    },
    closeText() {
      return this.storeHours?.today.close
    }
  },
  methods: {
    ...mapActions('DealerHeader', ['closeModal']),
    getNextOpenDay() {
      if (this.storeHours == null) return;

      // need a sorted list to do nextday operations
      const daysOfWeek = [
        'sunday',
        'monday',
        'tuesday',
        'wednesday',
        'thursday',
        'friday',
        'saturday'
      ];

      let nextDayIndex = new Date().getDay() + 1;
      let nextDayName = "";

      for (let i = 0; i < 6; i++) {
        nextDayName = daysOfWeek[nextDayIndex];
        if (this.storeHours[nextDayName].open) {
          break;
        }
        nextDayIndex = nextDayIndex === 6 ? 0 : nextDayIndex + 1;
      }

      const day = this.$options.filters.t(
        `dealers.details.storeHours.${nextDayName}`
      );
      const time = this.$options.filters.toShortTime(
        this.storeHours[nextDayName].open,
        { lowercase: true }
      );
      return `${day} at ${time}`;
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.current-store-hours {
  font-family: $font-text;
}
.time {
  color: $primary;
}
</style>
